import type { SxProps, Theme } from '@mui/material';

export const root: SxProps<Theme> = {
  width: '100%',
  alignItems: 'center',
  my: 4.5,
};

export const button: SxProps<Theme> = {
  whiteSpace: 'nowrap',
};
